import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
const root = ReactDOM.createRoot(document.getElementById('root'));
import 'semantic-ui-css/semantic.min.css'
axios.defaults.baseURL = 'https://panel.rahatsite.com/api'
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api'
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`
axios.interceptors.response.use((res)=>{
        return res
    }
    ,(error => {
        if (error.response.status === 401){
            toast.error('خطایی رخ داده است ،مجددا وارد حساب کاربری خود شوید', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            window.location.replace('/')
            window.localStorage.removeItem('token')

        }
        if (error.response.status === 404){
            alert.fire({
                title: '404',
                text: "Page was not found",
                icon: 'error',
                showConfirmButton: true,
                confirmButtonText: 'Back to home',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('/')
                }

            })

        }
        // if (error.response.status === 422){
        //     let errors = [];
        //     for (let error in error.response.data.errors)
        //         error.response.data.errors[error].forEach((item) =>
        //             errors.push(item)
        //         );
        //
        //     errors.map((item, index) => {
        //         toast.success(index + 1 + " - " + item , {
        //         position: "top-right",
        //         autoClose: 5000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         draggable: true,
        //         progress: undefined,
        //         theme: "dark",
        //     });
        //
        //     })
        //     // alert.fire({
        //     //     title: 'اطلاعات ناقص!',
        //     //     text:` ${}`,
        //     //     icon: 'error',
        //     //     showConfirmButton: true,
        //     //     confirmButtonText: 'متوجه شدم',
        //     //     reverseButtons: true
        //     // })
        // }
        if (error.response.status === 500){
            toast.error('خطا مجددا امتحان کنید', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });

        }

        return Promise.reject(error)
    }))
root.render(
  <React.StrictMode>
      <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
      />
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
